module.exports = __webpack_public_path__ + "images/menu-user-sel.svg?1787aad983a715e14dc235da95fda2aa";